import { render } from "./channel-join.vue?vue&type=template&id=dd0ccf1c&lang=pug"
import script from "./channel-join.vue?vue&type=script&lang=js"
export * from "./channel-join.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__